/** @type {Styles} */
export const styles = {
  snackbar: {
    top: {
      xs: 16,
      sm: 24,
    },
    zIndex: 1500,
  },

  outerContainer: (tokens) => ({
    border: `1px solid ${tokens.border}`,
    backgroundColor: tokens.background,
    borderRadius: '8px',
    boxShadow: tokens.shadow,
    overflow: 'hidden',
    width: {
      xs: 'calc(100vw - 32px)',
      sm: 324,
    },
  }),

  innerContainer: (hasDescription) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: hasDescription ? 'flex-start' : 'center',
    paddingX: 2,
    paddingY: 1.5,
  }),

  leftSection: (hasDescription) => ({
    display: 'flex',
    gap: 1,
    alignItems: hasDescription ? 'flex-start' : 'center',
    minWidth: 0,
    flex: 1,
  }),

  iconBadge: (tokens) => ({
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '8px',
    backgroundColor: tokens.iconBadge,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  iconSvg: {
    color: 'gray.0',
    fontSize: 24,
  },

  textColumn: {
    display: 'flex',
    flexDirection: 'column',
    paddingY: '2px',
    minWidth: 0,
  },

  titleText: {
    color: 'gray.100',
    lineHeight: '20px',
  },

  descriptionText: {
    color: 'gray.80',
    lineHeight: '20px',
  },

  rightSection: {
    display: 'flex',
    alignItems: 'flex-start',
    flexShrink: 0,
  },

  actionButton: {
    color: 'gray.80',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    padding: '2px 0',
    marginRight: 1,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  actionLink: {
    color: 'gray.80',
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    alignSelf: 'center',
    marginRight: 1,
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  closeButton: {
    padding: '4px',
    color: 'gray.80',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  closeIcon: {
    fontSize: 10,
  },
}
